import { postForFile } from './files';

export interface AccountsCheckerSummary {
  previous_sheet: string;
  previous_from: string;
  previous_to: string;
  current_sheet: string;
  current_from: string;
  current_to: string;
  rows: number;
  matched: number;
  new: number;
  not_matched: number;
  warnings: string[];
}

export function checkAccounts(file: File) {
  const form = new FormData();
  form.append('input_file', file);
  return postForFile<AccountsCheckerSummary>(
    '/accounts-checker/check',
    form,
    'Accounts_Checker.xlsx',
    'Checking the accounts failed'
  );
}
